<div id="home">
	@if(resellerSettingsContext.home.banner) {
	<app-landing-banner></app-landing-banner>
	}

	<div class="d-flex align-items-center justify-content-center flex-wrap">
		@for(dataItem of data; track dataItem; let index = $index) { @if (dataItem.type === 'topList') { @if ($first){
		<h5 class="w-100 d-flex justify-content-center mt-3 mb-0">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.HOME_TITLE_' + index | translate }}</h5>
		<div class="my-3 d-flex flex-wrap justify-content-center" [class]="mobileView ? 'w-100' : 'w-75'">
			@for (contractNotice of topListContractNotices; track contractNotice) {
			<mat-card class="w-25 me-4 my-2 px-4 py-3 top-list-item" [class]="mobileView ? 'w-100' : 'w-25'" appearance="outlined"  (click)="gotoLogin()">
				<mat-card-header>
					<mat-card-title-group>
						<mat-card-title>{{ getDisplayFieldByDataType('publishedDate', contractNotice) }}</mat-card-title>
						<mat-card-subtitle>{{ getDisplayFieldByDataType('title', contractNotice) }}</mat-card-subtitle>
					</mat-card-title-group>
				</mat-card-header>
				<mat-card-content>{{ getDisplayFieldByDataType('content', contractNotice) }}</mat-card-content>
			</mat-card>
			}
		</div>
		}} @else if (dataItem.type === 'stepBlocks') {
		<div class="d-flex w-100 justify-content-center pb-3 flex-wrap" [style.background-color]="$odd ? 'var(--theme-palette-100)' : ''">
			<div class="arrow-blocks-container my-3 d-flex flex-wrap justify-content-center" [class]="mobileView ? 'w-100' : 'w-75'">
				<h5 class="d-flex w-100 justify-content-center my-3">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.HOME_TITLE_' + index | translate }}</h5>
				@for (content of dataItem.content; track content) {
				<div class="me-2 p-4 pt-3 d-flex flex-wrap align-items-center" [ngClass]="$first ? 'block-first' : $last ? 'block-last' : 'block'">
					<span class="w-100 title mb-3">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.title | translate }}</span>
					<span class="w-100">
						{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.text | translate }}
					</span>
				</div>
				}
			</div>
      @if (dataItem.readMore) {
        <div class="d-flex w-100 justify-content-center">
          <button class="mt-3" mat-stroked-button color="primary" (click)="navigateToPage(dataItem.routerLink)">{{ 'BUTTON.READ_MORE' | translate }}</button>
        </div>
        }
		</div>
		} @else if (dataItem.type === 'text') {
		<div class="text-block-wrapper w-100 d-flex justify-content-center" [style.background-color]="$odd ? 'var(--theme-palette-100)' : ''">
			<div
				class="text-block-container d-flex flex-wrap align-items-center justify-content-center py-4"
				[ngClass]="[$even ? 'flex-row-reverse' : 'flex-row', mobileView ? 'w-100' : 'w-75']">
				@for(content of dataItem.content; track content; let contentIndex = $index) {
				<div class="d-flex flex-wrap p-3 pe-4 w-100" [ngClass]="{'w-50': dataItem.content.length > 1 || content.image, 'w-100': mobileView }">
					@if(content.leading) {
					<div class="d-flex w-100">
						<div class="blob me-2" [class]="$even ? 'style-1' : 'style-2'"></div>
						<span class="small-heading"> {{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.leading | translate }}</span>
					</div>
					}
					<div class="break"></div>
					@if(content.title) {
					<span class="heading mb-2">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.title | translate }}</span>
					}
					<div class="break"></div>
					<p class="m-0 p-0">
						@if (content.leading) {
						<strong>{{ 'LANDING.' + +(resellerSettingsContext.reseller.name | uppercase) + '.HOME_BLOCK_LEADING_' + index + '_' + contentIndex | translate }}</strong>
						}
						{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.HOME_BLOCK_' + index + '_' + contentIndex | translate }}
					</p>
					<div class="break"></div>
					<div class="break"></div>

					@if (dataItem.readMore) {
					<div class="d-flex w-100 justify-content-center">
						<button class="mt-3" mat-stroked-button color="primary" (click)="navigateToPage(dataItem.routerLink)">{{ 'BUTTON.READ_MORE' | translate }}</button>
					</div>
					}
				</div>

				@if(content.image) {
				<img class="img-fluid style-1 me-3" [src]="content.image" alt="home block image" />
				} }
			</div>
		</div>
		} @else if (dataItem.type === 'crawler') {
		<div class="py-4 w-100 d-flex justify-content-center" [style.background-color]="$odd ? 'var(--theme-palette-100)' : ''">
			<div class="text-block-container" [ngClass]="[$even ? 'flex-row-reverse' : 'flex-row', mobileView ? 'w-100' : 'w-75']">
				@if(dataItem.title) {
				<span class="heading mb-2">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + dataItem.title | translate }}</span>
				<div class="break"></div>
				} @if (dataItem.text) {
				<p class="m-0 p-0">
					{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + dataItem.text | translate }}
				</p>
				<div class="break"></div>
				<div class="break"></div>
				}
				<app-landing-horizontal-crawler [itemsList]="dataItem.content" (click)="navigateToPage(dataItem.routerLink)"></app-landing-horizontal-crawler>

				@if (dataItem.readMore) {
				<div class="d-flex w-100 justify-content-center">
					<button class="mt-3" mat-stroked-button color="primary" (click)="navigateToPage(dataItem.routerLink)">{{ 'BUTTON.READ_MORE' | translate }}</button>
				</div>
				}
			</div>
		</div>
		} @else {

		<div class="d-flex flex-wrap align-items-center justify-content-center py-4 gap-2" [class]="$even ? 'flex-row-reverse' : 'flex-row'">
			<div class="d-flex flex-wrap p-3" [class]="mobileView ? 'w-100' : 'w-25'">
				<div class="d-flex w-100">
					<div class="blob me-2" [class]="$even ? 'style-1' : 'style-2'"></div>
					<span class="small-heading"> {{ 'LANDING.' + resellerSettingsContext.reseller.name + '.HOME_TITLE_LEADING_' + index | translate }}</span>
				</div>
				<div class="break"></div>
				<span class="heading">{{ 'LANDING.' + resellerSettingsContext.reseller.name + '.HOME_TITLE_' + index | translate }}</span>
				<div class="break"></div>

				@for(content of dataItem.content; track content; let contentIndex = $index) {
				<p>
					@if (content.leading) {
					<strong>{{ 'LANDING.' + resellerSettingsContext.reseller.name + '.HOME_BLOCK_LEADING_' + index + '_' + contentIndex | translate }}</strong>
					}
					{{ 'LANDING.' + resellerSettingsContext.reseller.name + '.HOME_BLOCK_' + index + '_' + contentIndex | translate }}
				</p>
				<div class="break"></div>
				}
				<div class="break"></div>

				@if (dataItem.readMore) {
				<a [routerLink]="dataItem.routerLink"
					><span class="read-more"><mat-icon>keyboard_double_arrow_right</mat-icon></span>
				</a>
				}
			</div>
			<img class="img-fluid style-1" [src]="this.assetsPath + dataItem.image" alt="home block image" />
		</div>

		<div class="break"></div>
		<mat-divider class="w-50 mb-4"></mat-divider>
		<div class="break"></div>
		} }
	</div>
</div>
